import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getPlaces, getPlaceDetails } from "../../../helpers";
import { Spinner } from "../../../assets";
import { TransitionGroup, CSSTransition } from "react-transition-group";

export default function AddressSection({ values, onChange }) {

	const [query, setQuery] = useState("");
	const [places, setPlaces] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	// const [address, setAddress] = useState(null);

	const address = values.address;

	if (error) console.log("ERROR requesting addresses: ", error);

	const {
		session: { token }
	} = useSelector(state => ({
		session: state.session
	}));

	useEffect(() => {
		setLoading(true);
		const to = setTimeout(() => {
			setError("");
			getPlaces(query, token)
				.then(setPlaces)
				.catch(setError)
				.finally(() => {
					setLoading(false);
				});
		}, 500);
		return () => {
			clearTimeout(to);
		}
	}, [query, token]);

	return <div className="addressSection">
		<div className="details">
			Set the address your shop operates from.
			<br/><br/>
			Try searching for your address in plain text <i>"16 London Road"</i>, or if your business already has an address on Google, try searching the business name <i>"Epic Cakes Ltd"</i>.
		</div>
		<input
			type="text"
			placeholder="Search for your address.."
			value={query}
			onChange={e => {
				if (address)
					onChange({ address: null });
				setQuery(e.target.value);
			}}
		/>

		{/* <CSSTransition key="spinner">
		</CSSTransition> */}
		{Boolean(query && loading) && <Spinner />}
		<TransitionGroup>
			{!address && !loading && places.map(place => (
				<CSSTransition
					key={place.id}
					timeout={300}
					classNames="list-anim"
				>
					<button className="place" onClick={e => {
						// setAddress({ ...place })
						setLoading(true);
						getPlaceDetails(place.id, token)
							.then(address => {
								setQuery("");
								setPlaces([]);
								onChange({ address });
							})
							.catch(setError)
							.finally(() => {
								setLoading(false);
							});
					}}>
						{place.name}
					</button>
				</CSSTransition>
			))}
		</TransitionGroup>
		<TransitionGroup>
			{Boolean(address) && <CSSTransition
				key="address"
				timeout={300}
				classNames="list-anim"
			>
				<div className="address-fields">
					<h3>
						Amend if need be, search again or continue
					</h3>
					<input
						type="text"
						value={address.line1}
						placeholder="Line 1"
						onChange={e => onChange({ address: { ...address, line1: e.target.value, mapLink: null, location: null } })}
					/>
					<input
						type="text"
						value={address.line2}
						placeholder="Line 2"
						onChange={e => onChange({ address: { ...address, line2: e.target.value, mapLink: null, location: null } })}
					/>
					<input
						type="text"
						value={address.town}
						placeholder="Town"
						onChange={e => onChange({ address: { ...address, town: e.target.value, mapLink: null, location: null } })}
					/>
					<input
						type="text"
						value={address.postCode}
						placeholder="Postcode"
						onChange={e => onChange({ address: { ...address, postCode: e.target.value, mapLink: null, location: null } })}
					/>
				</div>
			</CSSTransition>}
		</TransitionGroup>
	</div>
}
